import React from 'react';
import Header from '../../../components/Header';
import OperatingInstructions from './OperatingInstructions';
const OperatingInstruction = () => {
  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <Header title={'Operating Instruction'} />
      <div className="flex-1 overflow-auto">
        <OperatingInstructions />
      </div>
    </div>
  );
};

export default OperatingInstruction;
